import {recordPaneOpen, setCurrentPane, setPrevPane} from "./commit_helpers";

export function openPaneComponent(sm, newPane) {
    setPrevPane(sm, newPane);

    // Before Callbacks
    fireBeforeBlurPaneCallback(sm, newPane);
    fireBeforeFocusPaneCallback(sm, newPane);

    setCurrentPane(sm, newPane);

    // After Callbacks
    fireAfterBlurPaneCallback(sm, newPane);
    fireAfterFocusPaneCallback(sm, newPane);

    recordPaneOpen(sm, newPane);
}




// Private…

// When the current pane is about to change we call the before focus callback.
function fireBeforeFocusPaneCallback(sm, pane) {
    if (sm.state['currentPaneId'] !== pane.identifier) {
        if (pane.onBeforeFocus) pane.onBeforeFocus();
    }
}

// When the current pane is about to loose focus (blur) we call its before blur callback.
function fireBeforeBlurPaneCallback(sm, newPane) {
    let oldPane = getPaneByIdentifier(sm.state['currentPaneId'], newPane.getPanesManager());
    if (oldPane && newPane.identifier !== oldPane.identifier) {
        if (oldPane.onBeforeBlur) oldPane.onBeforeBlur();
    }
}

// When the previous pane has just lost focus (blur) we call its after blur callback.
function fireAfterBlurPaneCallback(sm, newPane) {
    let oldPane = getPaneByIdentifier(sm.state['prevPaneId'], newPane.getPanesManager());
    if (oldPane && newPane.identifier !== oldPane.identifier) {
        if (oldPane.onAfterBlur) oldPane.onAfterBlur();
    }
}

// When the current pane has just changed we call the after focus callback.
function fireAfterFocusPaneCallback(sm, pane) {
    if (sm.state['currentPaneId'] == pane.identifier && sm.state['prevPaneId'] !== pane.identifier) {
        if (pane.onAfterFocus) pane.onAfterFocus();
    }
}


function getPaneByIdentifier(identifier, panesManager) {
    if (identifier && panesManager) return panesManager.findPaneByIdentifier(identifier);
}